import React from "react";
import "../Style/feedback.css";
const FeedbackBanner = () => {
  return (
    <div className=" flex justify-center items-center text-white z-50 contact-banner">
      <h1 className=" text-white text-[32px] lg:text-[40px] mt-14 font-semibold leading-[97px]">
        Feedback
      </h1>
    </div>
  );
};

export default FeedbackBanner;
